import { Component } from '@angular/core'
import { SidebarComponent } from '../sidebar/sidebar.component'
import { HeaderComponent } from '@src/app/inbetween/components/header/header.component'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
import { CommonModule } from '@angular/common'
import { Router } from '@angular/router'
import { UrlToLinkTitlePipe } from '@shared/pipes/url-to-link-title.pipe'
@Component({
  selector: 'app-main-layout',
  standalone: true,
  imports: [SidebarComponent, HeaderComponent, FontAwesomeModule, CommonModule, UrlToLinkTitlePipe],
  templateUrl: './main-layout.component.html',
  styleUrl: './main-layout.component.sass',
})
export class MainLayoutComponent {
  constructor(private readonly router: Router) {}

  get currentUrl(): string {
    return this.router.url
  }

  isSidebarOpen: boolean

  toggleSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen
  }
}
